import { placeholder } from "./shared";

export default {
  svgData: [
    {
      id: "slide1tv1",
      name: "TV",
      assets: [
        placeholder
      ],
      label: "slide1tv1"
    },
    {
      id: "slide1display1",
      name: "Display 1",
      assets: [
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/welcome/fact-sheet.jpg"
      ],
      label: "slide1display1"
    },
    {
      id: "slide1easel1",
      name: "Easel1",
      // multi viewer thing
      label: "slide1easel1"
    },
    {
      id: "slide1avatar1"
    }
  ],
  slideTitle: "Welcome",
  aboutText: `
  <p class="text-justify help"> This virtual meeting room showcases project information and
  concepts that you might find at a Georgia DOT public meeting. Here you
  can explore different stations or spaces that include handouts, proposed
  project concepts, environmental displays, and the opportunity to submit
  public comment.</p>
  <p class="text-justify help"> The Welcome Station includes a welcome video from Georgia DOT
  staff, and a project fact sheet on the table. The easel to the right is
  a project overview display that includes the Project Map, Need and
  Purpose, and Project Schedule.</p>
  <p class="text-justify help"> The project team is accepting public comment on the projects from
  <strong><u>now until Wednesday, July 13, 2022</u></strong>. We encourage
  you to submit public comment for the project. Please take a few moments
  to review the project information and design concepts on the project
  website and the virtual meeting room stations.</p>
  <p class="text-justify help"> Comments may be submitted via the online survey in the Comment
  Station, emailed at <a
  href="mailto:P3Division@dot.ga.gov">P3Division@dot.ga.gov</a>, or sent
  through U.S. mail to Mr. Eric Duff, Georgia DOT at 600 West Peachtree
  Street, NW – 16th Floor, Atlanta, Georgia 30308.</p>
  <p class="text-justify help"> If you have any questions, please feel free to contact us at <a
  href="mailto:P3Division@dot.ga.gov">P3Division@dot.ga.gov</a>.</p>
  
`,
helpText: `
  <p class="text-justify help"> Thank you for entering the virtual meeting room for the SR 316
  Bundle 2 Design-Build projects hosted by the Georgia Department of
  Transportation (Georgia DOT). The Department has published updated
  project information on its project website. This interactive, virtual
  meeting room platform houses the same project information that you would
  find at an in-person Public Information Open House (PIOH) for the
  following projects:</p>
  <ul>
  <li><blockquote>
  <p class="text-justify help"> <strong>SR 8/SR 316/US 29 at Virgil Langford Road (P.I. No.
  0013768)</strong></p>
  </blockquote></li>
  <li><blockquote>
  <p class="text-justify help"> <strong>SR 8/SR 316/US 29 at Oconee Connector (P.I. No.
  0013769)</strong></p>
  </blockquote></li>
  </ul>
  <p class="text-justify help"> As you enter each station or space of the virtual meeting room,
  you will receive a pop-up message detailing what resources and specific
  information are available to you. We encourage you to click on the
  virtual staff members and assets that are labeled to learn more about
  the project. In the first space, or Welcome Station, we recommend the
  following actions to help you learn more about the proposed SR 316
  Bundle 2 Design-Build projects:</p>
  <ul>
  <li><blockquote>
  <p class="text-justify help"> Watch the <strong><u>Welcome Video</u></strong> to become more
  familiar with our interactive, virtual meeting room.</p>
  </blockquote></li>
  <li><blockquote>
  <p class="text-justify help"> Click the document on the table to review the project
  <strong><u>Fact Sheet</u></strong>.</p>
  </blockquote></li>
  <li><blockquote>
  <p class="text-justify help"> Click the Project Overview Displays easel to the right to view
  the <strong><u>Project Map</u></strong>, <strong><u>Need and
  Purpose</u></strong>, and <strong><u>Project
  Schedule</u></strong>.</p>
  </blockquote></li>
  </ul>
  <p class="text-justify help"> Once your tour of the welcome space is complete, we invite you to
  visit the next station by clicking on the right arrow or selecting your
  station of choice from the navigation sidebar on the right.For additional information, 
  click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i>
  to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i>
  to see this message again after you close it out. To return to the project website, 
  select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i>icon.
  </p>
  `,
// _reminderText: `
//   <p class="text-justify help">
//   The SR 316 Express Lanes project will be the state’s first Public-Private Partnership (P3), Design-Build-Finance-Maintain (DBFM) project.
//   </p>
//   <p class="text-justify help">
//   In July 2020, Georgia DOT shortlisted three proposers for the SR 316 Express Lanes final design and construction. Only one of the three proposers submitted a responsive proposal. The executive summary is an overview of the proposer’s proposal that provides information on its ability to satisfy the financial and technical requirements of the project. 
//   </p>
//   <p class="text-justify help">
//   <b>Review the informational handout and the proposer’s executive summary, and following your review, submit online comment.</b>
//   </p>
//   <p class="text-justify help">
//   Your feedback is important to us! Click the tablet on the table to submit an official comment about the executive summary. <b>Comments should be submitted by Saturday, July 3, 2021. </b>
//   </p>
//   <p class="text-justify help">
//   Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out.</b> Feel free to navigate back to other stations in the virtual meeting space for additional project information. 
//   </p>
//    `
};
